import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import StandardModal from 'shared/StandardModal.jsx';
import StandardField from 'shared/StandardField.jsx';
import StandardTextArea from 'shared/StandardTextArea.jsx';
import DollarInputField from 'shared/DollarInputField.jsx';
import StandardSelectField from 'shared/StandardSelectField.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';
import ErrorListContainer from 'shared/error/ErrorListContainer.jsx';
import EntryDetailRefundModalVirtualEntriesToModifyContainer from './EntryDetailRefundModalVirtualEntriesToModifyContainer.jsx';

const EntryDetailRefundModal = ({
  visible,
  onCancelClick,
  handleSubmit,
  onSubmit,
  entryId,
  paymentType,
  refundType,
  purchaseTransactions
}) =>(
  <StandardModal
    title="Refund"
    visible={visible}
    onCloseClick={onCancelClick}>
      <div style={{overflowY: "auto"}}>
        { refundType === 'refundWithCancellation'
          ? <p>Please enter refund amount below if a refund was also issued with this cancellation. Otherwise, you are only required to add applicable notes.</p>
          : null
        }
        <form
          onSubmit={handleSubmit(onSubmit)}>
          <ErrorListContainer />
          <Field name="entryId"
            value={entryId}
            type="hidden"
            component={StandardField} />
          <label>Select Refund Method</label>
          <div
            className="form-group"
            style={{display: 'flex', flexFlow: 'column'}}
            >
            <label>
              <Field
                name="paymentType"
                component="input"
                type="radio"
                value="Cash"/>
                {' Cash'}
            </label>
            <label>
              <Field
                name="paymentType"
                component="input"
                type="radio"
                value="Check"/>
                {' Check'}
            </label>
            <label>
              <Field
                name="paymentType"
                component="input"
                type="radio"
                value="USBC Credit"/>
                {' USBC Credit'}
            </label>
            <label>
              <Field
                name="paymentType"
                component="input"
                type="radio"
                value="USBC Carryover"/>
                {' USBC Carryover'}
            </label>
            <label>
              <Field
                name="paymentType"
                component="input"
                type="radio"
                value="Manual Stripe Transaction"/>
                {' Manual Stripe Transaction'}
            </label>
            <label>
              <Field
                name="paymentType"
                component="input"
                type="radio"
                disabled={purchaseTransactions.length === 0}
                value="Stripe Purchase Transaction"/>
                {' Stripe Purchase Transaction'}
            </label>
          </div>
          <DisplayIf condition={paymentType == 'Check'}>
            <div className="form-group">
              <Field
                name="checkNumber"
                component={StandardField}
                placeholder="Check Number"
                style={{width: '30%'}}
              />
            </div>
          </DisplayIf>
          <DisplayIf condition={paymentType == 'Manual Stripe Transaction'}>
            <div className="form-group">
              <Field
                name="stripeTransactionId"
                component={StandardField}
                placeholder="Stripe Transaction Id"
                style={{width: '80%'}}
              />
            </div>
          </DisplayIf>
          <DisplayIf condition={paymentType == 'Stripe Purchase Transaction'}>
            <div className="form-group">
              <Field
                name="stripeTransactionId"
                component={StandardSelectField}
                placeholder="Stripe Transaction Id"
                options={purchaseTransactions.map(x => ({
                          value: x.creditCardTransactionId,
                          label: x.shortDescription
                }))}
                simpleValue
                required
                style={{width: '80%'}}
              />
            </div>
          </DisplayIf>
          <div style={{marginBottom: 20}}>
            <Field
              name="amount"
              label="Refund Amount"
              placeholder="US Dollars"
              component={DollarInputField}
              style={{width: '25%'}}
            />
          </div>
          <div className="form-group">
            <Field
              name="notes"
              component={StandardTextArea}
              placeholder="Notes go here"
              maxLength="255"
            />
          </div>
          <div className="form-group text-right">
              <button
                type="button"
                className="btn btn-link"
                onClick={() => onCancelClick()}
              >Cancel</button>
              {` `}
              <button
                type="submit"
                className="btn btn-primary btn-lg"
              ><i className="fa fa-floppy-o" /> {'Save'}</button>
          </div>
          
        { refundType === 'refundWithCancellation'
          ? <EntryDetailRefundModalVirtualEntriesToModifyContainer/>
          : null
        } 
        </form>
      </div>
    </StandardModal>
);

EntryDetailRefundModal.propTypes = {
  visible: PropTypes.bool,
  onCancelClick: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  entryId: PropTypes.string,
  paymentType: PropTypes.string,
  refundType: PropTypes.string,
  purchaseTransactions: PropTypes.arrayOf(PropTypes.object)
};

export default reduxForm({
  form: 'adminEntryRefundForm'
})(EntryDetailRefundModal);



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryDetailRefundModal.jsx